import React from 'react';

type SidebarToggleIconProps = {
  className?: string;
};

export const SidebarToggleIcon = ({
  className = 'w-4 h-4',
}: SidebarToggleIconProps) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <rect
        x="3.5"
        y="3.5"
        width="17"
        height="17"
        rx="4"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path
        d="M9 6.5V17.5"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <rect
        x="5.5"
        y="6.5"
        width="2"
        height="11"
        rx="1"
        fill="currentColor"
        opacity="0.65"
      />
    </svg>
  );
};
